import { render, staticRenderFns } from "./NsIcon.vue?vue&type=template&id=36192c72&scoped=true&"
import script from "./NsIcon.vue?vue&type=script&lang=js&"
export * from "./NsIcon.vue?vue&type=script&lang=js&"
import style0 from "./NsIcon.vue?vue&type=style&index=0&id=36192c72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../packages/aem/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36192c72",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/webcomponents-ui - release-finish/src/main/content/webcomponents/js/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36192c72')) {
      api.createRecord('36192c72', component.options)
    } else {
      api.reload('36192c72', component.options)
    }
    module.hot.accept("./NsIcon.vue?vue&type=template&id=36192c72&scoped=true&", function () {
      api.rerender('36192c72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/@nuskin/ns-icon/components/NsIcon.vue"
export default component.exports